<template>
  <div>
    <section id="about" class="ptb-100">
      <div class="container" v-if="content">
        <div v-html="content"></div>
      </div>
      <div class="container" style="height: 800px;" v-else>
        <i class="el-icon-loading" style="color: #409EFF; font-size: 80px; position: relative; left: 40%;"/>
      </div>
    </section>
  </div>
</template>

<script>
import {getHeadInfo} from '../api/index'
export default {
  name: 'menu',
  data () {
    return {
      id: '',
      title: '',
      content: ''
    }
  },
  mounted() {
    // 从路由参数获取菜单ID和标题
    this.id = this.$route.query.id;
    this.title = this.$route.query.title;

    // 根据菜单ID获取内容
    this.fetchContent();
  },
  watch: {
    // 监听路由变化，当用户点击不同菜单时重新加载内容
    '$route'(to, from) {
      if (to.query.id !== from.query.id) {
        this.id = to.query.id;
        this.title = to.query.title;
        this.content = ''; // 重置内容
        this.fetchContent();
      }
    }
  },
  methods: {
    fetchContent() {
      // 如果有ID，则根据ID从API获取内容
      if (this.id) {
        // 这里应该调用API获取具体内容
        this.getContentById(this.id);
      }
    },

    // 根据ID获取菜单内容的API调用
    async getContentById(id) {
      try {
        let response = await getHeadInfo(this.id)
        if (response && response.code === 0 && response.data) {
          this.title = response.data.title
          this.content = response.data.content
        } else {
          this.$message.error(response.msg)
        }
      } catch (error) {
        console.error('获取菜单内容失败:', error);
        this.content = '内容加载失败';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Menu.vue?24e3702e